import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Only preloads routes that explicitly opt in via `data: { preload: true }`.
 * All other lazy routes are loaded on first navigation to that route.
 *
 * To mark a route for background preloading, add `data: { preload: true }` to
 * its route definition:
 *
 *   {
 *     path: 'fees',
 *     loadChildren: () => import('./finance/finance.routes').then(m => m.FINANCE_ROUTES),
 *     data: { preload: true },
 *   }
 *
 * Routes WITHOUT `data.preload` are loaded only when the user navigates to them.
 * This strategy is registered in app.config.ts via:
 *   provideRouter(APP_ROUTES, withPreloading(SelectivePreloadStrategy))
 */
@Injectable({ providedIn: 'root' })
export class SelectivePreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    return route.data?.['preload'] === true ? load() : of(null);
  }
}
